var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-row',{staticClass:"groups"},[_c('b-col',{attrs:{"xl":"4"}},[_c('b-form-select',{attrs:{"value":_vm.value ? _vm.value.id : null,"options":_vm.groupsSelect},on:{"change":_vm.onChange}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }